export default "/kiban/_next/static/images/33_10L_2-6-2-59862f72591d7360153f87cd8dc684c4.png";